// extracted by mini-css-extract-plugin
export default {"icon":"Icon-icon_arD8t"};